import { useNavigate } from 'react-router-dom';
import { ScanFace, ChevronRight } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { idvMeta } from '../../lib/identityStatus';

// Prominent mandatory-ID card on the client onboarding checklist.
export const IdentityStatusCard = ({ data }) => {
  const navigate = useNavigate();
  const sec = data.sections.find((s) => s.key === 'identity_verification');
  const m = idvMeta(sec?.response_data?.didit_status || (sec?.status === 'in_progress' ? 'In Progress' : null), data.id_verification_status, data.id_verification_manual);
  return (
    <Card className={m.ok ? 'border-green-200' : 'border-2 border-primary/40 bg-primary/5'} data-testid="identity-status-card">
      <CardContent className="flex flex-wrap items-center gap-4 py-5">
        <ScanFace className="h-8 w-8 text-primary" />
        <div className="flex-1">
          <p className="font-semibold text-foreground">Identity verification <span className="text-xs font-normal text-red-500">required</span></p>
          <p className="text-sm text-muted-foreground">{m.ok ? (m.detail || 'Your identity is verified.') : 'You must verify your identity with our verification partner before you can submit your onboarding.'}</p>
        </div>
        <Badge className={m.color} data-testid="identity-status-badge">{m.label}</Badge>
        {!m.ok && <Button onClick={() => navigate('/onboarding/section/identity_verification')} data-testid="identity-status-open">{m.retry ? 'Try again' : 'Verify now'}<ChevronRight className="ml-1 h-4 w-4" /></Button>}
      </CardContent>
    </Card>
  );
};
